import { ActionCategory } from "../../generated/core/v1/actions";

/** The plan's action categories in words (the prototype's DSTC labels). */
export const CATEGORY_LABEL: Record<ActionCategory, string> = {
  [ActionCategory.ESSENTIAL]: "Essentials",
  [ActionCategory.HOUSING]: "Home",
  [ActionCategory.LIFESTYLE]: "Lifestyle",
  [ActionCategory.DEBT_MINIMUM]: "Debt payments",
  [ActionCategory.DEBT_EXTRA]: "Paying debt down faster",
  [ActionCategory.PRIORITY]: "Your priorities",
  [ActionCategory.SAVING]: "Saved and invested",
  [ActionCategory.WITHDRAWAL]: "Drawn from savings",
  [ActionCategory.OTHER]: "Everything else",
  [ActionCategory.UNSPECIFIED]: "Everything else",
};
